import {
  Button,
  Grid,
  Group,
  Loader,
  Modal,
  Select,
  Text,
  TextInput,
} from "@mantine/core";
import dayjs from "dayjs";
import "jspdf-autotable";
import { FaCalendar } from "react-icons/fa";
import NumericKeyboard from "../../NumericKeyboard";

export default function CreateTicketTeclado({
  showNumericModal,
  setShowNumericModal,
  state,
  numericCode,
  setNumericCode,
  selectedPeriod,
  setSelectedPeriod,
  selectedMeal,
  setSelectedMeal,
  selectedDate,
  setSelectedDate,
  selectedTime,
  setSelectedTime,
  handleNumericSubmit,
  submitting,
}) {
  const currentPeriod = state.periodos.find((p) => p.value === selectedPeriod);
  const currentMeal =
    currentPeriod?.comidas?.find(
      (c) => String(c.value) === String(selectedMeal)
    ) || null;

  const minTime = currentMeal?.minTime || "";
  const maxTime = currentMeal?.maxTime || "";

  console.warn("minTime", minTime);
  console.warn("maxTime", maxTime);

  return (
    <Modal
      opened={showNumericModal}
      onClose={() => {
        setNumericCode("");
        setSelectedPeriod("");
        setSelectedMeal("");
        setSelectedDate(
          dayjs(new Date()).tz("America/Guayaquil").format("YYYY-MM-DD")
        );
        setSelectedTime("");
        setShowNumericModal(false);
      }}
      title="Crear Ticket con Código"
      size="xl"
    >
      <Grid gutter="md">
        <Grid.Col span={4}>
          <Select
            label="Periodo"
            data={state.periodos}
            value={selectedPeriod}
            onChange={(value) => {
              setSelectedPeriod(value);
              setSelectedMeal("");
            }}
            required
          />
        </Grid.Col>
        <Grid.Col span={3}>
          <Select
            label="Comida"
            data={
              state.periodos.find((p) => p.value === selectedPeriod)?.comidas ||
              []
            }
            value={selectedMeal}
            onChange={setSelectedMeal}
            disabled={!selectedPeriod}
            required
          />
        </Grid.Col>
        <Grid.Col span={2}>
          <TextInput
            label={
              !selectedMeal
                ? "Hora"
                : `${minTime && maxTime ? ` (${minTime} - ${maxTime})` : ""}`
            }
            type="time"
            value={selectedTime}
            onChange={(e) => setSelectedTime(e.target.value)}
            min={minTime || undefined}
            max={maxTime || undefined}
            disabled={!selectedMeal}
            required
          />
        </Grid.Col>
        <Grid.Col span={3}>
          <TextInput
            label="Fecha"
            type="date"
            min={dayjs(
              state.periodos.find((p) => p.value === selectedPeriod)?.minDate
            ).format("YYYY-MM-DD")}
            max={dayjs(
              state.periodos.find((p) => p.value === selectedPeriod)?.maxDate
            ).format("YYYY-MM-DD")}
            icon={<FaCalendar size={14} />}
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            disabled={!selectedPeriod}
            required
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <TextInput
            value={numericCode}
            readOnly
            placeholder="Escribe el código con el teclado..."
            styles={{
              input: {
                background: "#d7d7d7",
                color: "black",
                width: "100%",
                borderRadius: "15px",
                border: "none",
                height: "40px",
                fontSize: "2rem",
                textAlign: "center",
                fontWeight: "bold",
              },
            }}
          />
          {/* Botones Borrar y OK */}
          <Group grow mt="md">
            <Button
              color="red"
              onClick={() => setNumericCode("")}
              style={{ height: "50px", borderRadius: "15px" }}
            >
              <Text size="xl">Borrar</Text>
            </Button>
            <Button
              color="teal"
              onClick={handleNumericSubmit}
              disabled={
                !selectedPeriod ||
                !selectedMeal ||
                !numericCode ||
                !selectedTime
              }
              style={{ height: "50px", borderRadius: "15px" }}
            >
              {submitting ? (
                <Loader size="sm" color="white" variant="dots" />
              ) : (
                <Text size="xl">OK</Text>
              )}
            </Button>
          </Group>
        </Grid.Col>

        <Grid.Col span={12}>
          <NumericKeyboard
            onKeyClick={(key) => {
              if (key === "enter") handleNumericSubmit();
              else if (key === "borrar") setNumericCode("");
              else setNumericCode((prev) => prev + key);
            }}
            hideControls={true}
          />
          {/* Letras especiales */}
          <Group position="center" mt="md" spacing="xs">
            {["V", "P", "E", "G", "X", "S", "T"].map((char) => (
              <Button
                key={char}
                onClick={() => setNumericCode((prev) => prev + char)}
                variant="outline"
                style={{
                  width: "70px",
                  height: "70px",
                  borderWidth: "2px",
                  borderColor: "#4f46e5",
                }}
              >
                <Text size="xl" weight={700}>
                  {char}
                </Text>
              </Button>
            ))}
          </Group>
        </Grid.Col>
      </Grid>
    </Modal>
  );
}
